"use client";

import Link from "next/link";

import { usePathname, useSearchParams } from "next/navigation";

import {
  ASIAN_BASKET_GROCERY_DEPARTMENTS,
  ASIAN_BASKET_TAKEOUT_DEPARTMENTS,
  ASIAN_BASKET_GROCERY_DEPARTMENT_ORDER,
  ASIAN_BASKET_TAKEOUT_DEPARTMENT_ORDER,
} from "@/lib/asianBasketTaxonomy";

const HIDDEN_NAV_PATHS = [
  "/checkout",
  "/order-confirmation",
  "/login",
  "/signup",
  "/privacy-policy",
  "/terms",
  "/blog",
  "/accessibility",
  "/about-us",
  "/account",
];

export default function BottomDepartmentNav() {
  const pathname = usePathname();

  const searchParams = useSearchParams();

  /* =====================================================
     HIDE NAV
     ===================================================== */

  const shouldHide = HIDDEN_NAV_PATHS.some((path) =>
    pathname?.startsWith(path),
  );

  if (shouldHide) {
    return null;
  }

  /* =====================================================
     STOREFRONT TYPE
     ===================================================== */

  const isTakeout = pathname?.startsWith("/shop/take-out");

  /* =====================================================
     TAKEOUT
     ===================================================== */

  const activeTakeoutDepartment =
    searchParams.get("department") || ASIAN_BASKET_TAKEOUT_DEPARTMENT_ORDER[0];

  /* =====================================================
     NAV DATA
     ===================================================== */

  const navigationItems = isTakeout
    ? ASIAN_BASKET_TAKEOUT_DEPARTMENT_ORDER
    : ASIAN_BASKET_GROCERY_DEPARTMENT_ORDER;

  const departments = isTakeout
    ? ASIAN_BASKET_TAKEOUT_DEPARTMENTS
    : ASIAN_BASKET_GROCERY_DEPARTMENTS;

  return (
    <nav
      className={`asian-bucket-sidebar-main-wrapper ${
        isTakeout ? "is-takeout" : "is-grocery"
      }`}
      aria-label={isTakeout ? "Takeout departments" : "Grocery departments"}
    >
      <div className="asian-bucket-bottom-navigation-main-wrapper">
        {navigationItems.map((slug) => {
          const department = departments[slug];

          if (!department) {
            return null;
          }

          const href = isTakeout
            ? `/shop/take-out?department=${slug}`
            : `/shop/${slug}`;

          const isActive = isTakeout
            ? activeTakeoutDepartment === slug
            : pathname === `/shop/${slug}`;

          return (
            <Link
              key={slug}
              href={href}
              className={isActive ? "is-active" : ""}
            >
              {department.icon && <img src={department.icon} alt="" />}

              <span>{department.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
